"use client";

import React, { useState } from "react";
import { MdArrowRight } from "react-icons/md";
import { Typography } from "../shared/Typography";
import { CollapsibleContainerNodeType, renderNode } from "./serializeToReact";

interface CollapsibleContainerProps {
  node: CollapsibleContainerNodeType;
}

export default function CollapsibleContainer({ node }: CollapsibleContainerProps) {
  const [isOpen, setIsOpen] = useState(node?.open === true);

  return (
    <div>
      {node?.children?.map((child, index) => {
        if (child?.type !== "collapsible-title" && child?.type !== "collapsible-content") {
          return <React.Fragment key={index}></React.Fragment>;
        }

        const data = child.children?.map((child, index) => (
          <React.Fragment key={index}>{renderNode(child)}</React.Fragment>
        ));

        return (
          <React.Fragment key={index}>
            {child.type === "collapsible-title" && (
              <div
                className="flex items-center gap-2 py-2 pl-2 cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
              >
                <MdArrowRight
                  size={22}
                  className={
                    "text-black dark:text-white " + (isOpen ? " rotate-90 " : " rotate-0 ")
                  }
                />
                <Typography variant="h6" >
                  {data}
                </Typography>
              </div>
            )}
            {child.type === "collapsible-content" && isOpen && (
              <div className="pb-4 pl-4">{data}</div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
